import React from 'react';
import { Route, Switch } from "react-router-dom";
import { paths } from './config/router.config';
import PrecheckRoute from './services/permissions';

import LandingPage from './pages/landing-page/LandingPageController';
import HomePage from './pages/home/HomeController';
import LoginPage from './pages/login/LoginController';
import ResetPasswordPage from './pages/reset-password/ResetPasswordController';
import RegisterPage from './pages/register/RegisterControllerV2';
import SettingPage from './pages/setting/SettingController';
import PackageInfoPage from './pages/package-info/PackageInfoController';
import SupportPage from './pages/support/SupportController';
import NewSupportRequestPage from './pages/support/NewSupportRequestController';
import NotificationsPage from './pages/notifications/NotificationsController';
import NotificationDetailPage from './pages/notifications/NotificationDetailView';
import BillsPage from './pages/bills/BillsController';
import BillDetailPage from './pages/bills/BillDetailView';
import SubcriptionsPage from './pages/subcriptions/SubcriptionsController';
import SwapServicePage from './pages/subcriptions/SwapServiceController';
import OrdersResult from './pages/orders/OrdersResult';
import ReOrdersResult from './pages/orders/ReOrdersResult';
import ChangeServiceResult from './pages/orders/ChangeServiceResult';
import PackageContactPage from './pages/package-contact/PackageContactController';
import VumatelSmsPage from './pages/vumatel-sms/VumatelSms';
import VumatelReTryPayment from './pages/vumatel-pages/VumatelReTryPayment';
import VumatelReNewPayment from './pages/vumatel-pages/VumatelReNewPayment';
import VumatelUpdateCard from './pages/vumatel-pages/VumatelUpdateCard';
import PaymentResult from './pages/payment-result/PaymentResult';
import InvoicesController from './pages/invoices/InvoicesController';
import PaymentLinkPage from './pages/payments/PaymentLinkController';

export default function Routers() {
    return (
        <Switch>
            <Route path={paths.landing_page} component={LandingPage} />
            <Route path={paths.login} component={LoginPage} />
            <Route path={paths.register} component={RegisterPage} />
            <Route path={paths.reset_password} component={ResetPasswordPage} />
            <Route path={paths.package_info} component={PackageInfoPage} />
            <Route path={paths.orders_result} component={OrdersResult} />
            <Route path={paths.payment_result} component={PaymentResult} />
            <Route path={paths.vumatel_paymentlink} component={PaymentLinkPage} />
            <Route path={paths.vumatel_sms} component={VumatelSmsPage} />
            <Route path={paths.vumatel_retry_payment} component={VumatelReTryPayment} />
            <Route path={paths.vumatel_renew_payment} component={VumatelReNewPayment} />
            <Route path={paths.vumatel_update_card} component={VumatelUpdateCard} />
            <PrecheckRoute path={paths.setting} component={SettingPage} />
            <PrecheckRoute path={paths.setting} component={SettingPage} />
            <PrecheckRoute path={paths.support} component={SupportPage} />
            <PrecheckRoute path={paths.support_add} component={NewSupportRequestPage} />
            <PrecheckRoute path={paths.notifications} component={NotificationsPage} />
            <PrecheckRoute path={paths.notifications_detail} component={NotificationDetailPage} />
            <PrecheckRoute path={paths.bills} component={BillsPage} />
            <PrecheckRoute path={paths.bill_detail} component={BillDetailPage} />
            <PrecheckRoute path={paths.subcriptions} component={SubcriptionsPage} />
            <PrecheckRoute path={paths.swap_service} component={SwapServicePage} />
            {/* <PrecheckRoute path={paths.package_contact} component={PackageContactPage} /> */}
            <PrecheckRoute path={paths.reorders_result} component={ReOrdersResult} />
            <PrecheckRoute path={paths.change_service_result} component={ChangeServiceResult} />
            <PrecheckRoute path={paths.invoices} component={InvoicesController} />
            <PrecheckRoute path={"/"} component={HomePage} />
        </Switch>
    );
}
